import React from 'react';
import styles from './CustomRadioGroup.module.scss';

export interface RadioOption {
  value: string;
  label: string;
}

interface CustomRadioGroupProps {
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  name?: string;
  className?: string;
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  options,
  value,
  onChange,
  name = 'radioGroup',
  className
}) => {
  return (
    <div className={`${styles.radioGroup} ${className || ''}`}>
      {options.map((option) => (
        <label key={option.value} className={styles.radioLabel}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            className={styles.radioInput}
          />
          <svg
            className={styles.radioIcon}
            viewBox="0 0 14 14"
            width="14"
            height="14"
            aria-hidden="true"
          >
            {value === option.value ? (
              <circle
                cx="7"
                cy="7"
                r="4.5"
                fill="#FDFDFD"
                stroke="#0265DC"
                strokeWidth="5"
              />
            ) : (
              <circle
                cx="7"
                cy="7"
                r="6"
                fill="#FDFDFD"
                stroke="#6D6D6D"
                strokeWidth="2"
              />
            )}
          </svg>
          <span className={styles.radioText}>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default CustomRadioGroup;
